import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements AfterViewInit,OnInit {

  constructor(public shared: SharedService){
    this.shared.isWhiteMenu = true;
  }

  ngOnInit(): void{

  }

  ngAfterViewInit(): void{
    this.shared.includeMainScript();
  }
}
